import { ReactElement, useCallback, useRef, useState } from 'react';

import { FormHandles } from '@unform/core';
import { useHistory, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';

import { GoBackButton, Button, ConfirmModal } from '~/components';
import { useLoading } from '~/hooks/loading';
import { ISymbology } from '~/models/Symbology';
import { SymbologyService } from '~/services';
import { handleYupValidationError } from '~/utils';
import { SymbologySchema } from '~/utils/schemas/SymbologySchema';

import EditSymbologyForm from '../EditSymbologyForm';

import * as S from './styles';

interface EditSymbologyParams {
  symbologyId: string;
}

function EditExercise(): ReactElement {
  const { setLoading } = useLoading();

  const formRef = useRef<FormHandles>(null);
  const { symbologyId } = useParams<EditSymbologyParams>();
  const [confirmDeleteModal, setConfirmDeleteModal] = useState(false);
  const router = useHistory();

  const handleEditSymbologySubmit = useCallback(
    async (data: ISymbology) => {
      try {
        setLoading(true);

        formRef.current?.setErrors({});

        await SymbologySchema.validate(data, {
          abortEarly: false,
        });

        const result = await SymbologyService.editSymbology(symbologyId, data);
        if (result.status === 200) {
          toast.success('Simbologia editada com sucesso!');
          router.goBack();
        } else {
          toast.error('Ocorreu um problema ao editar a simbologia!');
        }

        setLoading(false);
      } catch (error) {
        setLoading(false);
        handleYupValidationError(formRef, error);
      }
    },
    [router],
  );

  const handleDeleteSymbology = useCallback(async () => {
    try {
      setLoading(true);

      const result = await SymbologyService.deleteSymbology(symbologyId);
      if (result.status === 200) {
        toast.success('Simbologia deletada com sucesso!');
        router.goBack();
      } else {
        toast.error('Ocorreu um problema ao deletada a simbologia!');
      }

      setLoading(false);
    } catch (error) {
      setLoading(false);
      handleYupValidationError(formRef, error);
    }
  }, [router]);

  return (
    <>
      <GoBackButton
        containerStyle={{ alignSelf: 'flex-start', paddingTop: '2.2rem' }}
      />
      <S.Container>
        <S.Header>
          <S.Title>Editar Simbologia</S.Title>
        </S.Header>
        <EditSymbologyForm
          formRef={formRef}
          formName="edit-symbology"
          handleSubmit={handleEditSymbologySubmit}
        />
        <S.Footer>
          <Button
            form="edit-symbology"
            type="submit"
            textContent="Salvar"
            variant="black"
            size="small"
            extraStyles={{
              width: '200px',
            }}
          />
          <Button
            onClick={() => setConfirmDeleteModal(true)}
            textContent="Excluir"
            variant="red"
            size="small"
            extraStyles={{
              width: '200px',
            }}
          />
        </S.Footer>
      </S.Container>
      <ConfirmModal
        modalIsVisible={confirmDeleteModal}
        setModalIsVisible={setConfirmDeleteModal}
        title="Deletar Simbologia"
        textContent={`Tem certeza que deseja deletar a simbologia ${formRef.current?.getFieldValue(
          'symbology',
        )} ?`}
        handleSubmit={handleDeleteSymbology}
      />
    </>
  );
}

export default EditExercise;
